export default "__VITE_ASSET__CADZmv1g__"